import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("RpsTO")
export class RpsTO {

  prestador: String;

  tomador: String;

  valor: number;

  codigoVerificador: string;

  validador: string;

}
